module.exports = __webpack_public_path__ + "31b85ed54977a47df4d246bd27f1fbf8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/frilly-flower-orange.png
// module id = 2197
// module chunks = 0